/**
 * Normalize backend/UI copy so frontend matches product rename rules.
 */

const REPLACEMENTS = [
  [/MShub\s*VIP/gi, "OMN VIP"],
  [/MShub\s*账户余额/gi, "账户资金"],
  [/MShub\s*直播广场/gi, "OMN直播间"],
  [/MShub\s*优质约爱平台/gi, ""],
  [/MShub/gi, "OMN"],
  [/账户余额/g, "账户资金"],
  [/积分/g, "余额"],
  [/金融卡/g, "银行账户"],
  [/国内身份/g, "会员身份"],
  [/直播广场/g, "直播间"],
  [/认证项目/g, "认证入口"],
  [/官方审核/g, "系统审核"],
  [/已认证资料/g, "已认证"],
  [/已完善资料/g, "已认证"],
  [/返回广场/g, "返回页面"],
  [/银行卡状态/g, "银行账户"],
  [/已绑定卡片/g, "已绑定"],
  [/审核通过/g, "已绑定"],
  [/持卡人/g, "ID"],
  [/激活入口/g, "认证入口"],
  [/资质认证\s*激活入口/g, "认证入口"],
  [/\b视频\b/g, "看片"],
  [/待审核/g, ""],
  [/今日累计/g, ""],
  [/地区或/g, ""],
];

export function sanitizeDisplayText(text) {
  if (text == null) {
    return text;
  }
  let value = String(text);
  REPLACEMENTS.forEach(([pattern, replacement]) => {
    value = value.replace(pattern, replacement);
  });
  return value.replace(/\s{2,}/g, " ").trim();
}

export function pickDisplayText(candidates, fallback) {
  const list = Array.isArray(candidates) ? candidates : [candidates];
  for (let i = 0; i < list.length; i += 1) {
    const raw = list[i];
    if (raw == null || raw === "") {
      continue;
    }
    const cleaned = sanitizeDisplayText(raw);
    if (cleaned) {
      return cleaned;
    }
  }
  return fallback != null ? sanitizeDisplayText(fallback) || fallback : "";
}
